exports["DE"] = require("./DE.js");
exports["IE"] = require("./IE.js");